import { useEffect, useState } from "react";
import { Plus, Pencil, Trash2, Clock, MapPin } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { AdminHeader } from "@/components/admin/AdminShared";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { formatDateShort } from "@/lib/helpers";

const EMPTY = { date: "", time: "", title: "", location: "", organizer: "", description: "" };

export default function AgendasAdmin() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [editId, setEditId] = useState(null);

  const load = () => api.get("/agendas").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const set = (k, v) => setForm({ ...form, [k]: v });
  const openNew = () => { setForm({ ...EMPTY, date: new Date().toISOString().slice(0, 10) }); setEditId(null); setOpen(true); };
  const openEdit = (a) => { setForm({ ...a, date: a.date.slice(0, 10) }); setEditId(a.id); setOpen(true); };

  const save = async () => {
    if (!form.title || !form.date) { toast.error("Judul dan tanggal wajib diisi"); return; }
    const payload = { ...form, date: new Date(form.date).toISOString() };
    if (editId) await api.put(`/agendas/${editId}`, payload);
    else await api.post("/agendas", payload);
    toast.success("Agenda disimpan");
    setOpen(false); load();
  };

  const del = async (id) => { await api.delete(`/agendas/${id}`); toast.success("Agenda dihapus"); load(); };

  return (
    <div>
      <AdminHeader title="Manajemen Agenda" description="Kelola jadwal kegiatan Bawaslu Sultra."
        action={<Button onClick={openNew} className="bg-brandred hover:bg-brandred-700 text-white" data-testid="add-agenda-btn"><Plus className="h-4 w-4 mr-1.5" /> Tambah Agenda</Button>} />

      <div className="grid md:grid-cols-2 gap-4">
        {items.map((a) => (
          <div key={a.id} className="bg-white border border-slate-200 rounded-xl p-5 flex gap-4" data-testid={`agenda-admin-${a.id}`}>
            <div className="shrink-0 h-14 w-14 rounded-lg bg-navy text-white flex flex-col items-center justify-center">
              <span className="text-lg font-extrabold leading-none">{new Date(a.date).getDate()}</span>
              <span className="text-[9px] uppercase">{new Date(a.date).toLocaleDateString("id-ID", { month: "short" })}</span>
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="font-bold text-navy line-clamp-1">{a.title}</h4>
              <div className="text-xs text-slate-500 mt-1 flex flex-wrap gap-x-3"><span className="flex items-center gap-1"><Clock className="h-3 w-3" />{a.time}</span><span className="flex items-center gap-1"><MapPin className="h-3 w-3" />{a.location}</span></div>
            </div>
            <div className="flex flex-col gap-1">
              <Button size="icon" variant="ghost" onClick={() => openEdit(a)} data-testid={`edit-agenda-${a.id}`}><Pencil className="h-4 w-4" /></Button>
              <Button size="icon" variant="ghost" onClick={() => del(a.id)} className="text-brandred"><Trash2 className="h-4 w-4" /></Button>
            </div>
          </div>
        ))}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg">
          <DialogHeader><DialogTitle>{editId ? "Edit" : "Tambah"} Agenda</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <div><Label>Kegiatan *</Label><Input value={form.title} onChange={(e) => set("title", e.target.value)} className="mt-1.5" data-testid="agenda-title" /></div>
            <div className="grid grid-cols-2 gap-4">
              <div><Label>Tanggal *</Label><Input type="date" value={form.date} onChange={(e) => set("date", e.target.value)} className="mt-1.5" data-testid="agenda-date" /></div>
              <div><Label>Waktu</Label><Input value={form.time} onChange={(e) => set("time", e.target.value)} placeholder="09:00 WITA" className="mt-1.5" /></div>
            </div>
            <div><Label>Lokasi</Label><Input value={form.location} onChange={(e) => set("location", e.target.value)} className="mt-1.5" /></div>
            <div><Label>Penyelenggara</Label><Input value={form.organizer} onChange={(e) => set("organizer", e.target.value)} className="mt-1.5" /></div>
            <div><Label>Deskripsi</Label><Textarea value={form.description} onChange={(e) => set("description", e.target.value)} rows={3} className="mt-1.5" /></div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Batal</Button>
            <Button onClick={save} className="bg-brandred hover:bg-brandred-700 text-white" data-testid="save-agenda">Simpan</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
